import Chapters from "../../pages/admin/chapters";
import Events from "../../pages/admin/events";
import Exams from "../../pages/admin/exams";
import Groups from "../../pages/admin/groups";
import Lectures from "../../pages/admin/lectures";
import Lessons from "../../pages/admin/lessons";
import QuestionsBank from "../../pages/admin/questions-bank";
import RedoRequests from "../../pages/admin/redo-requests";
import AttendanceReport from "../../pages/admin/reports/attendance";
import DownloadableReport from "../../pages/admin/reports/downloadable-report";
import ExamReport from "../../pages/admin/reports/exam";
import ExamAttendanceReport from "../../pages/admin/reports/exam-attendance";
import GroupsReport from "../../pages/admin/reports/groups";
import PaiedReport from "../../pages/admin/reports/paid-report";
import PrintableQuestions from "../../pages/admin/reports/printable-questions";
import UnpaiedReport from "../../pages/admin/reports/unpaid-report";
import VideoReport from "../../pages/admin/reports/video-views";
import ScanCode from "../../pages/admin/scan-code";
import Streaming from "../../pages/admin/streaming";
import StudentExamsList from "../../pages/admin/student-exams";
import Students from "../../pages/admin/students";
import Teachers from "../../pages/admin/teachers";
import TeachersAssistant from "../../pages/admin/teachersAssistant";
import Videos from "../../pages/admin/videos";
import Home from "../../pages/public/home";
import ChapterExams from "../../pages/student/exams/chapter-exams";
import ChaptersExamsList from "../../pages/student/exams/chapters-list";
import ExamResult from "../../pages/student/exams/exam-result";
import ExameGuide from "../../pages/student/exams/exame-guide";
import SolveExam from "../../pages/student/exams/solve-exam";
import StudentHome from "../../pages/student/home";
import StudentModelAnswer from "../../pages/student/model-answer";
import ModelAnswersChaptersList from "../../pages/student/model-answer/chapters-list";
import Questions from "../../pages/student/questions";
import QrCodeVideos from "../../pages/student/videos/qrcode-videos";
import VideosMoreViewRequests from "../../pages/superadmin/videosMoreViewRequests";
import ProtectedRouter from "../Auth/ProtectedRouter";

import StudentsPaymentList from "../../containers/admin/payment/paymentList";
import Homeworks from "../../pages/admin/homework";
import LiveVideos from "../../pages/admin/liveVideos";
import Payment from "../../pages/admin/payment";
import Playlists from "../../pages/admin/playlists";
import HomeworkAbsentReport from "../../pages/admin/reports/homework-absent";
import HomeworkAttendanceReport from "../../pages/admin/reports/homework-attendence";
import LiveVideosReport from "../../pages/admin/reports/livevideos-report";
import Sections from "../../pages/admin/sections";
import Tags from "../../pages/admin/tags";
import PublicCoursesList from "../../pages/public/courses-list";
import ChapterDetails from "../../pages/student/course-flow/chapter-details";
import ChaptersList from "../../pages/student/course-flow/chapters-list";
import CoursesList from "../../pages/student/course-flow/courses-list";
import SectionsList from "../../pages/student/course-flow/sections-list";
import StudentTeacherDetails from "../../pages/student/course-flow/teacher-details";
import TeashersList from "../../pages/student/course-flow/teacher-list";
import ExamsSectionsList from "../../pages/student/exams/sections-list";
import StudentHomeWork from "../../pages/student/homework";
import HomeworkChaptersList from "../../pages/student/homework/chapters-list";
import HomeworkSectionsList from "../../pages/student/homework/sections-list";
import StudentLiveVideos from "../../pages/student/live-videos";
import StudyCoursesList from "../../pages/student/studyWithEnough/courses-list";
import StudyWithEnoughExams from "../../pages/student/studyWithEnough/exams-list";
import StudyWithEnoughSolveExam from "../../pages/student/studyWithEnough/solve-exam";
import VideoPreviewPage from "../../pages/student/studyWithEnough/videoPreview";
import TeacherDetails from "../../pages/student/teachers/TeacherDetails";
import StudentVideo from "../../pages/student/videos";
import VideosPreview from "../../pages/student/videos/video-preview";
import SuperAdminBuckets from "../../pages/superadmin/buckets";
import SuperAdminChapters from "../../pages/superadmin/chapters";
import Courses from "../../pages/superadmin/courses";
import SuperadminEnrollCourseRequests from "../../pages/superadmin/enrollCourses";
import SuperadminExams from "../../pages/superadmin/exams";
import SuperadminGroups from "../../pages/superadmin/groups";
import SuperadminHomeworks from "../../pages/superadmin/homework";
import SuperadminLiveVideos from "../../pages/superadmin/live-videos";
import LiveVideosReportsPage from "../../pages/superadmin/live-videos-reports";
import SuperadminPayment from "../../pages/superadmin/payment";
import SuperadminPdfs from "../../pages/superadmin/pdfs";
import SuperadminQuestionsBank from "../../pages/superadmin/questions-bank";
import HomeworkUncommentReport from "../../pages/admin/reports/homework-uncomment";
import VideosAbsentReport from "../../pages/superadmin/reports/videos-absent-report";
import AttendanceSimpleReport from "../../pages/superadmin/reports/attendance-simple-report";
import SuperadminSections from "../../pages/superadmin/sections";
import SuperadminStudents from "../../pages/superadmin/students";
import ExportStudents from "../../pages/superadmin/export-students";
import Subjects from "../../pages/superadmin/subjects";
import SuperAdminTags from "../../pages/superadmin/tags";
import SuperadminTeachers from "../../pages/superadmin/teachers";
import SuperadminVideos from "../../pages/superadmin/videos";
import Login from "../Auth/login";
import Register from "../Auth/register";
import ChangepasswordForm from "../Auth/register/ChangepasswordForm";
import ForgetpasswordForm from "../Auth/register/ForgetpasswordForm";
import OTP from "../Auth/register/OTP";
const Routers = () => {
  return (
    <>
      {/* public */}
      <ProtectedRouter path="/" element={<Home />}></ProtectedRouter>
      {/* super admin */}
      <ProtectedRouter
        path="/dashboard/superadmin-subjects"
        element={<Subjects />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-courses"
        element={<Courses />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-teachers"
        element={<SuperadminTeachers />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-chapters"
        element={<SuperAdminChapters />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-students"
        element={<SuperadminStudents />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-export-students"
        element={<ExportStudents />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/superadmin-videos"
        element={<SuperadminVideos />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/superadmin-payment"
        element={<SuperadminPayment />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-pdfs"
        element={<SuperadminPdfs />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-tags"
        element={<SuperAdminTags />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-buckets"
        element={<SuperAdminBuckets />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-questions-bank"
        element={<SuperadminQuestionsBank />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-exams"
        element={<SuperadminExams />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-sections"
        element={<SuperadminSections />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/superadmin-live-videos"
        element={<SuperadminLiveVideos />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/superadmin-live-videos-reports"
        element={<LiveVideosReportsPage />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/superadmin-groups"
        element={<SuperadminGroups />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-videos-view-requests"
        element={<VideosMoreViewRequests />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/videos-more-view-requests"
        element={<VideosMoreViewRequests />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-course-enrolls"
        element={<SuperadminEnrollCourseRequests />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-students-payments"
        element={<Payment />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/superadmin-homework"
        element={<SuperadminHomeworks />}
      ></ProtectedRouter>
      {/* auth */}
      <ProtectedRouter path="/login" element={<Login />}></ProtectedRouter>
      <ProtectedRouter
        path="/forget-password"
        element={<ForgetpasswordForm />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/forget-password/otp"
        element={<OTP />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/forget-password/change-password"
        element={<ChangepasswordForm />}
      ></ProtectedRouter>

      <ProtectedRouter path="/otp" element={<OTP />}></ProtectedRouter>

      <ProtectedRouter
        path="/register"
        element={<Register />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/teacher/:id"
        element={<TeacherDetails />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/student/teacher/:id"
        element={<StudentTeacherDetails />}
      ></ProtectedRouter>
      {/* //dashboard */}
      <ProtectedRouter
        path="/teacher/:id/courses"
        element={<CoursesList />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/teacher/:id/courses/types"
        element={<PublicCoursesList />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/students"
        element={<Students />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/groups"
        element={<Groups />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/lessons"
        element={<Lessons />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/streaming"
        element={<Streaming />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/videos"
        element={<Videos />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/events"
        element={<Events />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/teachers"
        element={<Teachers />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/teachers-assistant"
        element={<TeachersAssistant />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/chapters"
        element={<Chapters />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/lectures"
        element={<Lectures />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/exams"
        element={<Exams />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/payments"
        element={<Payment />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/payment-subject"
        element={<SuperadminPayment />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/homework"
        element={<Homeworks />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/payment-list/:payment_id"
        element={<StudentsPaymentList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/tags"
        element={<Tags />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/playlists"
        element={<Playlists />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/student-exams"
        element={<StudentExamsList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/buckets"
        element={<SuperAdminBuckets />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/questions-bank"
        element={<QuestionsBank />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/exam-redo-requests"
        element={<RedoRequests />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/downloaded-reports"
        element={<DownloadableReport />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/attendence-report"
        element={<AttendanceReport />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/exam-attendence-report"
        element={<ExamAttendanceReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/exam-report"
        element={<ExamReport />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/homework-attendence-report"
        element={<HomeworkAttendanceReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/homework-absent-report"
        element={<HomeworkAbsentReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/videos-report"
        element={<VideoReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/videos-absent-report"
        element={<VideosAbsentReport />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/attendence-simple-report"
        element={<AttendanceSimpleReport />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/sections"
        element={<Sections />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/live-videos"
        element={<LiveVideos />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/groups-report"
        element={<GroupsReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/live-videos-report/:video_id"
        element={<LiveVideosReport />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/dashboard/print-all-questions"
        element={<PrintableQuestions />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/unpaid-report"
        element={<UnpaiedReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/paid-report"
        element={<PaiedReport />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/dashboard/uncomment-homework-report"
        element={<HomeworkUncommentReport />}
      ></ProtectedRouter>

      {/* students */}
      <ProtectedRouter path="/home" element={<StudentHome />}></ProtectedRouter>
      <ProtectedRouter
        path="/course/:id/sections/:type"
        element={<SectionsList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/section/:id/chapters/:type"
        element={<ChaptersList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/chapter/:id/:type"
        element={<ChapterDetails />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/teachers"
        element={<TeashersList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/video/:id"
        element={<StudentVideo />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/video/video-preview/:id"
        element={<VideosPreview />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/model-answers/chapters"
        element={<ModelAnswersChaptersList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/model-answer/:id"
        element={<StudentModelAnswer />}
      ></ProtectedRouter>
      <ProtectedRouter
        exact
        path="/homework/:id"
        element={<StudentHomeWork />}
      ></ProtectedRouter>
      <ProtectedRouter
        exact
        path="/homeworks/chapters/:id"
        element={<HomeworkChaptersList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/homeworks/sections"
        element={<HomeworkSectionsList />}
      ></ProtectedRouter>
      <ProtectedRouter
        exact
        path="/scan-code/:id/:type"
        element={<ScanCode />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/exams/sections"
        element={<ExamsSectionsList />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/exams/chapters/:id"
        element={<ChaptersExamsList />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/exam/:id"
        element={<ChapterExams />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/student/exams"
        element={<ChapterExams />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/exam-guide/:id"
        element={<ExameGuide />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/student/exam-guide/:id"
        element={<ExameGuide />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/solve-exam/:id"
        element={<SolveExam />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/study-with-enough/video-preview/:id"
        element={<VideoPreviewPage />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/student/solve-exam/:id"
        element={<SolveExam />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/homework/solve-exam/:id"
        element={<SolveExam />}
      ></ProtectedRouter>

      <ProtectedRouter
        path="/homework/exam-guide/:id"
        element={<ExameGuide />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/exam-result/:id"
        element={<ExamResult />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/questions"
        element={<Questions />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/video/qr-code/:video_id"
        element={<QrCodeVideos />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/live-videos"
        element={<StudentLiveVideos />}
      ></ProtectedRouter>
      <ProtectedRouter
        path="/courses/study-with-agwad/"
        element={<StudyCoursesList />}
        exact
      ></ProtectedRouter>
      <ProtectedRouter
        path="/study-with-agwad/:id"
        element={<StudyWithEnoughExams />}
        exact
      ></ProtectedRouter>

      <ProtectedRouter
        path="/study/:id"
        element={<StudyWithEnoughSolveExam />}
      ></ProtectedRouter>
    </>
  );
};

export default Routers;
